import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCRefLovProps, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import { useForm, useWatch } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import ModalSide from "src/components/Modal/styles";
import Modal from "src/components/Modal";
import LovDimensions from "src/components/Lov/Dimensions";
import stringToNumber from "src/utils/stringToNumber";
import { IRefAlterDimensionModal } from "../interface";

const AlterDimensionModal: React.ForwardRefRenderFunction<IRefAlterDimensionModal> = (_,ref) => {
	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	const [onCloseFunction,setOnCloseFunction] = useState<((dimensionId?:number)=>void )>();
	const [selectedSwot, setSelectedSwot] = useState<{id:number,title:string}>();

	const modalAddOrChange = useRef<RCCRefModalProps>(null);
	const lovRef = useRef<RCCRefLovProps>(null);

	const { 
		handleSubmit,
		control,
		reset, 
		setError, 
		formState: { errors }, 
		clearErrors
	} = useForm();

	const submit = async (data: any) => {
		try{
			clearErrors();
			modalAddOrChange.current?.setLoadingButton();
			
			if(!data.mes002Taa011Id){
				addToast({
					color: "yellow",
					description: translate("Selecione uma dimensão"),
					title: translate("Aviso")
				});
				modalAddOrChange.current?.resetLoadingButton();
				return;
			}
			
			await RCCServicesApi.putRequest({
				method: "SWOT/UpdateSwotDimension",
				urlParameters: {
					swotItemId:selectedSwot?.id,
					dimension:data.mes002Taa011Id
				}
			});
	
			addToast({
				color: "green",
				description: translate("Dimensão alterada com sucesso" ),
				title: translate("Sucesso")
			});

			modalAddOrChange.current?.resetLoadingButton();
			modalAddOrChange.current?.closeModal();
			if(onCloseFunction)
				onCloseFunction(parseInt(data.mes002Taa011Id,10) as number);

		}catch(err){

			modalAddOrChange.current?.resetLoadingButton();
			if(getValidationErrors(err, setError))
				return;

			standardErrorMessages(err, translate("Erro ao alterar dimensão"), addToast);
		}
	};
	
	const actionOpenModal = (swot:{id:number,title:string},onClose?:(taa011Id:number)=>void) => {
		reset();
		setSelectedSwot(swot);
		setOnCloseFunction(() => onClose);
		modalAddOrChange.current?.resetLoadingButton();
		modalAddOrChange.current?.openModal();
	};

	const lovWatch = useWatch({
		control,
		name: "mes002Taa011Id"
	});

	useImperativeHandle(ref, () => ({
		actionOpenModal
	}));

	useEffect(() => {
		if (stringToNumber(lovWatch) <= 0)
			lovRef.current?.clearValue();
	}, [lovWatch]);

	return (
		<>
			<Modal
				ref={modalAddOrChange}
				header={{
					title: translate("Alterar dimensão"),
					subtitle:selectedSwot?.title,
					icon: {
						name: "table"
					}
				}}
				onSubmit={handleSubmit(submit)}
				styleInline={ModalSide}
			>
				<RCCGrid 
					container 
					item 
					justifyContent="center">
					<RCCGrid
						container
						item
						xs={12}
						sm={10}
					>
						<LovDimensions 
							name="mes002Taa011Id" 
							label={translate("Nova dimensão")} 
							control={control}
							required
							extraParametersOnLoad={{
								useConsolidated: false
							}}
							error={errors.mes002Taa011Id}
							ref={lovRef}
						/>
					</RCCGrid>
				</RCCGrid>
			</Modal>
		</>
	);
};

export default forwardRef(AlterDimensionModal);
